export interface AdminUser {
  _id: string;
  name: string;
  email: string;
  phoneNumber?: string;
}

export interface AdminUserRecord {
  _id: string;
  firstName: string;
  lastName: string;
  email?: string;
  phoneNumber?: string;
  profileComplete: boolean;
  role: 'user' | 'author' | 'admin';
  bookCount: number;
  createdAt: string;
  lastActiveAt?: string;
}

export interface UserListSummary {
  total: number;
  newLast7Days: number;
  newLast30Days: number;
  profileIncomplete: number;
  noBooks: number;
  declinedTerms: number;
}

export interface UserListResponse {
  users: AdminUserRecord[];
  total: number;
  totalPages: number;
  page: number;
  summary: UserListSummary;
}

export type UserFilter = 'all' | 'no_books' | 'incomplete_profile' | 'new_7d' | 'new_30d' | 'declined_terms';

export interface PdfFile {
  fileId?: string;
  filename?: string;
}

export interface AdminBook {
  _id: string;
  title: string;
  subtitle?: string;
  author: string;
  language: string;
  bookSize?: string;
  status: 'draft' | 'submitted' | 'approved' | 'rejected';
  user?: AdminUser;
  uploadedFile?: { fileId?: string; filename?: string; originalName?: string; contentType?: string };
  content?: { html?: string; json?: any };
  coverImage?: string | { fileId?: string; filename?: string };
  finalPDF?: PdfFile & { version?: number; generatedAt?: string };
  isbn?: string;
  hasISBN?: boolean;
  addons?: { spellcheck?: boolean; coverDesign?: boolean; coverDesignType?: string | null };
  aiCoverGenerations?: number;
  totalVersions: number;
  currentVersion: number;
  createdAt: string;
  updatedAt: string;
  submittedAt?: string;
  reviewedAt?: string;
  pageCount?: number;
  bindingType?: string;
  paperType?: string;
  interiorColor?: string;
  coverLamination?: string;
}

export type JourneyType = 'Uploaded PDF' | 'Editor' | 'Unknown';

export function getJourneyType(book: AdminBook): JourneyType {
  if (book.uploadedFile?.fileId) return 'Uploaded PDF';
  if (book.content?.html && book.content.html.trim().length > 0) return 'Editor';
  return 'Unknown';
}

export interface Version {
  _id: string;
  book: string;
  versionNumber: number;
  pdfFile?: PdfFile;
  status: 'submitted' | 'approved' | 'rejected';
  comment?: string;
  reviewedBy?: AdminUser;
  reviewedAt?: string;
  createdAt: string;
  updatedAt: string;
}

export interface BookDetailResponse {
  success: boolean;
  book: AdminBook;
  versions: Version[];
}
